export default `
query isEmailAvailable($email: String!) {
  isEmailAvailable(email: $email) {
    is_email_available
  }
}
`;
